import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

type UsePageUrlClick = () => (url: string) => void;
export const usePageUrlClick: UsePageUrlClick = () => {
  const history = useHistory();

  return useCallback(
    (url: string) => {
      history.push(url);
    },
    [history]
  );
};
